import { combineReducers } from 'redux';

import available from './available';
import isProcessing from './isProcessing';
import my from './my';

/**
 * @typedef {{
 *   my: import('./my').AuditModelDashboardMyUIReducer,
 *   available: import('./available').AuditModelDashboardAvailableUIReducer,
 *   isProcessing: boolean,
 * }} AuditModelDashboardUIReducer
 */
export default combineReducers({
  my,
  available,
  isProcessing,
});
